module.exports = __webpack_public_path__ + "img/new_xt.png";